import React from "react";
import { observer } from "mobx-react";
import { computed, observable } from "mobx";
import { FieldRenderProps } from "react-final-form";
import { ValueType } from "react-select";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddIcon from "@material-ui/icons/Add";

import { Button, FormLabel, Typography } from "@material-ui/core";

import Popup from "components/Popup";
import Placeholder from "components/Placeholder";
import withFieldControl from "components/FormControl/FieldControl";

import TagsForm from "./TagsForm";

import { isObject } from "utils";

import { DictionaryItem } from "constants/models";

import {
  MultiValues,
  MultiValue,
  MultiValueClear,
} from "components/Input/Dropdown/styles";

import { Container, ControlHeader, ControlContainer, Row } from "./styles";

type Props = { existingTags: any };

@observer
class TagsControl extends React.Component<FieldRenderProps<any> & Props> {
  @observable isPopupOpen: boolean = false;

  @computed
  get values() {
    const { provider, options, input } = this.props;
    const currentOptions = provider?.options || options;
    const value = input?.value || [];
    return value.map(item =>
      currentOptions?.find(findItem =>
        isObject(item)
          ? findItem.value.id === item?.id
          : findItem.value === item,
      ),
    );
  }

  @computed get newTagsOptions() {
    const { options } = this.props;

    return options.filter(
      option => !this.values.find(({ value }) => value === option.value),
    );
  }

  onChange = (items: DictionaryItem[] = []) => {
    const {
      input: { onChange },
    } = this.props;

    const value = items.map(item => item.value);
    const event: any = { target: { value } };
    onChange(event);
  };

  onRemoveItem = (value: ValueType<DictionaryItem>) => () => {
    const values = this.values.filter(item => item !== value);
    this.onChange(values);
  };

  closePopup = () => {
    this.isPopupOpen = false;
  };

  openPopup = () => {
    this.isPopupOpen = true;
  };

  saveNewTags = (newTags: DictionaryItem[]) => {
    this.onChange([...this.values, ...newTags]);
    this.closePopup();
  };

  render() {
    return (
      <>
        {this.isPopupOpen && (
          <Popup
            onClose={this.closePopup}
            canCloseByOuterClick={false}
            withoutExitButton
          >
            <TagsForm
              onClose={this.closePopup}
              options={this.newTagsOptions}
              onSave={this.saveNewTags}
            />
          </Popup>
        )}
        <Container>
          <Row>
            <ControlHeader>
              <FormLabel>Tags</FormLabel>
              <ControlContainer>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  startIcon={<AddIcon />}
                  onClick={this.openPopup}
                >
                  Add Tags
                </Button>
              </ControlContainer>
            </ControlHeader>
          </Row>

          {this.values.length ? (
            <Row>
              <MultiValues>
                {this.values.map(item => (
                  <MultiValue
                    key={isObject(item) ? item?.value?.id : item?.value}
                  >
                    <Typography variant="subtitle1">{item?.label}</Typography>
                    <MultiValueClear onClick={this.onRemoveItem(item)}>
                      <DeleteOutlineIcon />
                    </MultiValueClear>
                  </MultiValue>
                ))}
              </MultiValues>
            </Row>
          ) : (
            <Placeholder height={132} width={132} text={"No tags added yet."} />
          )}
        </Container>
      </>
    );
  }
}

export default withFieldControl(TagsControl);
